function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "5.296999931335449 254.9250030517578 349.1619873046875 111.70500183105469",
    xmlSpace: "preserve",
    height: 16.706466101344,
    width: 53.184804928131,
    y: "0px",
    x: "0px",
    id: "Laag_1_1554210053980",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.605,255.069h27.688v106.624h-27.591v-43.76h-40.127v43.812H90.797v-106.65h27.701v2.263  c0,12.272,0,24.538-0.032,36.804c0,1.53,0.257,2.147,1.993,2.134c12.08-0.077,24.165-0.039,36.251-0.045  c0.546,0,1.086-0.051,1.883-0.09L158.605,255.069z",
    fill: "#FFFFFF",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.305,254.966c-0.572,0.868-0.926,1.427-1.285,1.961c-10.967,15.493-21.941,30.979-32.921,46.459  c-0.823,1.157-0.778,1.929,0,3.041c12.497,17.803,24.964,35.623,37.401,53.459c0.379,0.541,0.739,1.1,1.254,1.865  c-0.721,0.045-1.234,0.109-1.749,0.109c-10.112,0-20.218,0-30.33,0.031c-1.093,0.101-2.135-0.485-2.616-1.472  c-6.355-10.491-12.752-20.942-19.189-31.353c-0.386-0.643-0.784-1.24-1.285-1.992c-0.515,0.7-0.951,1.285-1.376,1.87  c-7.56,10.496-15.112,20.996-22.654,31.5c-0.56,0.944-1.604,1.494-2.7,1.421c-9.983-0.059-19.974,0-29.957,0h-1.929  c0.585-0.849,0.971-1.446,1.396-2.019c13.05-17.786,26.121-35.561,39.214-53.325c0.938-1.286,0.881-2.083,0.032-3.336  c-10.32-15.398-20.619-30.816-30.896-46.253c-0.359-0.546-0.7-1.106-1.253-1.967h2.115c10.048,0,20.096,0,30.144,0  c1.473,0,2.27,0.399,2.97,1.755c4.378,8.543,8.865,17.029,13.468,25.823c0.477-0.643,0.855-1.164,1.195-1.69  c5.221-8.1,10.46-16.155,15.609-24.242c0.603-1.14,1.835-1.8,3.117-1.671C285.68,254.992,296.279,254.966,307.305,254.966z",
    fill: "#FFFFFF",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.297,278.598v-23.516h73.195v23.445H55.884V361.7H28.086v-83.103H5.297z",
    fill: "#FFFFFF",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.97,364.612c-8.948,0.237-16.425-7.116-16.477-16.464c-0.045-8.955,7.535-16.599,16.471-16.451  c9.276,0.154,16.014,7.072,16.47,15.654C352.98,357.695,344.462,365.037,335.97,364.612z",
    fill: "#17D1AF",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.67ba5cd7.svg";
export { ForwardRef as ReactComponent };